/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  fixDecoderSize,
  fixEncoderSize,
  getBytesDecoder,
  getBytesEncoder,
  getStructDecoder,
  getStructEncoder,
  SOLANA_ERROR__PROGRAM_CLIENTS__INSUFFICIENT_ACCOUNT_METAS,
  SolanaError,
  transformEncoder,
  type AccountMeta,
  type AccountSignerMeta,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
  type Instruction,
  type InstructionWithAccounts,
  type InstructionWithData,
  type ReadonlyAccount,
  type ReadonlySignerAccount,
  type ReadonlyUint8Array,
  type TransactionSigner,
  type WritableAccount,
} from "@solana/kit";
import {
  getAccountMetaFactory,
  getAddressFromResolvedInstructionAccount,
  type ResolvedInstructionAccount,
} from "@solana/program-client-core";
import {
  findEventAuthorityPda,
  findPoolAuthorityPda,
  findTokenVaultPda,
} from "../pdas/index.js";
import { CP_AMM_PROGRAM_ADDRESS } from "../programs/index.js";

export const CLAIM_POSITION_FEE_DISCRIMINATOR: ReadonlyUint8Array =
  new Uint8Array([180, 38, 154, 17, 133, 33, 162, 211]);

export function getClaimPositionFeeDiscriminatorBytes(): ReadonlyUint8Array {
  return fixEncoderSize(getBytesEncoder(), 8).encode(
    CLAIM_POSITION_FEE_DISCRIMINATOR,
  );
}

export type ClaimPositionFeeInstruction<
  TProgram extends string = typeof CP_AMM_PROGRAM_ADDRESS,
  TAccountPoolAuthority extends string | AccountMeta<string> = string,
  TAccountPool extends string | AccountMeta<string> = string,
  TAccountPosition extends string | AccountMeta<string> = string,
  TAccountTokenAAccount extends string | AccountMeta<string> = string,
  TAccountTokenBAccount extends string | AccountMeta<string> = string,
  TAccountTokenAVault extends string | AccountMeta<string> = string,
  TAccountTokenBVault extends string | AccountMeta<string> = string,
  TAccountTokenAMint extends string | AccountMeta<string> = string,
  TAccountTokenBMint extends string | AccountMeta<string> = string,
  TAccountPositionNftAccount extends string | AccountMeta<string> = string,
  TAccountOwner extends string | AccountMeta<string> = string,
  TAccountTokenAProgram extends string | AccountMeta<string> =
    "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
  TAccountTokenBProgram extends string | AccountMeta<string> =
    "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA",
  TAccountEventAuthority extends string | AccountMeta<string> = string,
  TAccountProgram extends string | AccountMeta<string> =
    "cpamdpZCGKUy5JxQXB4dcpGPiikHawvSWAd6mEn1sGG",
  TRemainingAccounts extends readonly AccountMeta<string>[] = [],
> = Instruction<TProgram> &
  InstructionWithData<ReadonlyUint8Array> &
  InstructionWithAccounts<
    [
      TAccountPoolAuthority extends string
        ? ReadonlyAccount<TAccountPoolAuthority>
        : TAccountPoolAuthority,
      TAccountPool extends string
        ? ReadonlyAccount<TAccountPool>
        : TAccountPool,
      TAccountPosition extends string
        ? WritableAccount<TAccountPosition>
        : TAccountPosition,
      TAccountTokenAAccount extends string
        ? WritableAccount<TAccountTokenAAccount>
        : TAccountTokenAAccount,
      TAccountTokenBAccount extends string
        ? WritableAccount<TAccountTokenBAccount>
        : TAccountTokenBAccount,
      TAccountTokenAVault extends string
        ? WritableAccount<TAccountTokenAVault>
        : TAccountTokenAVault,
      TAccountTokenBVault extends string
        ? WritableAccount<TAccountTokenBVault>
        : TAccountTokenBVault,
      TAccountTokenAMint extends string
        ? ReadonlyAccount<TAccountTokenAMint>
        : TAccountTokenAMint,
      TAccountTokenBMint extends string
        ? ReadonlyAccount<TAccountTokenBMint>
        : TAccountTokenBMint,
      TAccountPositionNftAccount extends string
        ? ReadonlyAccount<TAccountPositionNftAccount>
        : TAccountPositionNftAccount,
      TAccountOwner extends string
        ? ReadonlySignerAccount<TAccountOwner> &
            AccountSignerMeta<TAccountOwner>
        : TAccountOwner,
      TAccountTokenAProgram extends string
        ? ReadonlyAccount<TAccountTokenAProgram>
        : TAccountTokenAProgram,
      TAccountTokenBProgram extends string
        ? ReadonlyAccount<TAccountTokenBProgram>
        : TAccountTokenBProgram,
      TAccountEventAuthority extends string
        ? ReadonlyAccount<TAccountEventAuthority>
        : TAccountEventAuthority,
      TAccountProgram extends string
        ? ReadonlyAccount<TAccountProgram>
        : TAccountProgram,
      ...TRemainingAccounts,
    ]
  >;

export type ClaimPositionFeeInstructionData = {
  discriminator: ReadonlyUint8Array;
};

export type ClaimPositionFeeInstructionDataArgs = {};

export function getClaimPositionFeeInstructionDataEncoder(): FixedSizeEncoder<ClaimPositionFeeInstructionDataArgs> {
  return transformEncoder(
    getStructEncoder([["discriminator", fixEncoderSize(getBytesEncoder(), 8)]]),
    (value) => ({ ...value, discriminator: CLAIM_POSITION_FEE_DISCRIMINATOR }),
  );
}

export function getClaimPositionFeeInstructionDataDecoder(): FixedSizeDecoder<ClaimPositionFeeInstructionData> {
  return getStructDecoder([
    ["discriminator", fixDecoderSize(getBytesDecoder(), 8)],
  ]);
}

export function getClaimPositionFeeInstructionDataCodec(): FixedSizeCodec<
  ClaimPositionFeeInstructionDataArgs,
  ClaimPositionFeeInstructionData
> {
  return combineCodec(
    getClaimPositionFeeInstructionDataEncoder(),
    getClaimPositionFeeInstructionDataDecoder(),
  );
}

export type ClaimPositionFeeAsyncInput<
  TAccountPoolAuthority extends string = string,
  TAccountPool extends string = string,
  TAccountPosition extends string = string,
  TAccountTokenAAccount extends string = string,
  TAccountTokenBAccount extends string = string,
  TAccountTokenAVault extends string = string,
  TAccountTokenBVault extends string = string,
  TAccountTokenAMint extends string = string,
  TAccountTokenBMint extends string = string,
  TAccountPositionNftAccount extends string = string,
  TAccountOwner extends string = string,
  TAccountTokenAProgram extends string = string,
  TAccountTokenBProgram extends string = string,
  TAccountEventAuthority extends string = string,
  TAccountProgram extends string = string,
> = {
  poolAuthority?: Address<TAccountPoolAuthority>;
  pool: Address<TAccountPool>;
  position: Address<TAccountPosition>;
  /** The user token a account */
  tokenAAccount: Address<TAccountTokenAAccount>;
  /** The user token b account */
  tokenBAccount: Address<TAccountTokenBAccount>;
  /** The vault token account for input token */
  tokenAVault?: Address<TAccountTokenAVault>;
  /** The vault token account for output token */
  tokenBVault?: Address<TAccountTokenBVault>;
  /** The mint of token a */
  tokenAMint: Address<TAccountTokenAMint>;
  /** The mint of token b */
  tokenBMint: Address<TAccountTokenBMint>;
  /** The token account for nft */
  positionNftAccount: Address<TAccountPositionNftAccount>;
  /** owner of position */
  owner: TransactionSigner<TAccountOwner>;
  /** Token a program */
  tokenAProgram?: Address<TAccountTokenAProgram>;
  /** Token b program */
  tokenBProgram?: Address<TAccountTokenBProgram>;
  eventAuthority?: Address<TAccountEventAuthority>;
  program?: Address<TAccountProgram>;
};

export async function getClaimPositionFeeInstructionAsync<
  TAccountPoolAuthority extends string,
  TAccountPool extends string,
  TAccountPosition extends string,
  TAccountTokenAAccount extends string,
  TAccountTokenBAccount extends string,
  TAccountTokenAVault extends string,
  TAccountTokenBVault extends string,
  TAccountTokenAMint extends string,
  TAccountTokenBMint extends string,
  TAccountPositionNftAccount extends string,
  TAccountOwner extends string,
  TAccountTokenAProgram extends string,
  TAccountTokenBProgram extends string,
  TAccountEventAuthority extends string,
  TAccountProgram extends string,
  TProgramAddress extends Address = typeof CP_AMM_PROGRAM_ADDRESS,
>(
  input: ClaimPositionFeeAsyncInput<
    TAccountPoolAuthority,
    TAccountPool,
    TAccountPosition,
    TAccountTokenAAccount,
    TAccountTokenBAccount,
    TAccountTokenAVault,
    TAccountTokenBVault,
    TAccountTokenAMint,
    TAccountTokenBMint,
    TAccountPositionNftAccount,
    TAccountOwner,
    TAccountTokenAProgram,
    TAccountTokenBProgram,
    TAccountEventAuthority,
    TAccountProgram
  >,
  config?: { programAddress?: TProgramAddress },
): Promise<
  ClaimPositionFeeInstruction<
    TProgramAddress,
    TAccountPoolAuthority,
    TAccountPool,
    TAccountPosition,
    TAccountTokenAAccount,
    TAccountTokenBAccount,
    TAccountTokenAVault,
    TAccountTokenBVault,
    TAccountTokenAMint,
    TAccountTokenBMint,
    TAccountPositionNftAccount,
    TAccountOwner,
    TAccountTokenAProgram,
    TAccountTokenBProgram,
    TAccountEventAuthority,
    TAccountProgram
  >
> {
  // Program address.
  const programAddress = config?.programAddress ?? CP_AMM_PROGRAM_ADDRESS;

  // Original accounts.
  const originalAccounts = {
    poolAuthority: { value: input.poolAuthority ?? null, isWritable: false },
    pool: { value: input.pool ?? null, isWritable: false },
    position: { value: input.position ?? null, isWritable: true },
    tokenAAccount: { value: input.tokenAAccount ?? null, isWritable: true },
    tokenBAccount: { value: input.tokenBAccount ?? null, isWritable: true },
    tokenAVault: { value: input.tokenAVault ?? null, isWritable: true },
    tokenBVault: { value: input.tokenBVault ?? null, isWritable: true },
    tokenAMint: { value: input.tokenAMint ?? null, isWritable: false },
    tokenBMint: { value: input.tokenBMint ?? null, isWritable: false },
    positionNftAccount: {
      value: input.positionNftAccount ?? null,
      isWritable: false,
    },
    owner: { value: input.owner ?? null, isWritable: false },
    tokenAProgram: { value: input.tokenAProgram ?? null, isWritable: false },
    tokenBProgram: { value: input.tokenBProgram ?? null, isWritable: false },
    eventAuthority: { value: input.eventAuthority ?? null, isWritable: false },
    program: { value: input.program ?? null, isWritable: false },
  };
  const accounts = originalAccounts as Record<
    keyof typeof originalAccounts,
    ResolvedInstructionAccount
  >;

  // Resolve default values.
  if (!accounts.poolAuthority.value) {
    accounts.poolAuthority.value = await findPoolAuthorityPda();
  }
  if (!accounts.tokenAVault.value) {
    accounts.tokenAVault.value = await findTokenVaultPda({
      tokenMint: getAddressFromResolvedInstructionAccount(
        "tokenAMint",
        accounts.tokenAMint.value,
      ),
      pool: getAddressFromResolvedInstructionAccount(
        "pool",
        accounts.pool.value,
      ),
    });
  }
  if (!accounts.tokenBVault.value) {
    accounts.tokenBVault.value = await findTokenVaultPda({
      tokenMint: getAddressFromResolvedInstructionAccount(
        "tokenBMint",
        accounts.tokenBMint.value,
      ),
      pool: getAddressFromResolvedInstructionAccount(
        "pool",
        accounts.pool.value,
      ),
    });
  }
  if (!accounts.tokenAProgram.value) {
    accounts.tokenAProgram.value =
      "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA" as Address<"TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA">;
  }
  if (!accounts.tokenBProgram.value) {
    accounts.tokenBProgram.value =
      "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA" as Address<"TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA">;
  }
  if (!accounts.eventAuthority.value) {
    accounts.eventAuthority.value = await findEventAuthorityPda();
  }
  if (!accounts.program.value) {
    accounts.program.value =
      "cpamdpZCGKUy5JxQXB4dcpGPiikHawvSWAd6mEn1sGG" as Address<"cpamdpZCGKUy5JxQXB4dcpGPiikHawvSWAd6mEn1sGG">;
  }

  const getAccountMeta = getAccountMetaFactory(programAddress, "programId");
  return Object.freeze({
    accounts: [
      getAccountMeta("poolAuthority", accounts.poolAuthority),
      getAccountMeta("pool", accounts.pool),
      getAccountMeta("position", accounts.position),
      getAccountMeta("tokenAAccount", accounts.tokenAAccount),
      getAccountMeta("tokenBAccount", accounts.tokenBAccount),
      getAccountMeta("tokenAVault", accounts.tokenAVault),
      getAccountMeta("tokenBVault", accounts.tokenBVault),
      getAccountMeta("tokenAMint", accounts.tokenAMint),
      getAccountMeta("tokenBMint", accounts.tokenBMint),
      getAccountMeta("positionNftAccount", accounts.positionNftAccount),
      getAccountMeta("owner", accounts.owner),
      getAccountMeta("tokenAProgram", accounts.tokenAProgram),
      getAccountMeta("tokenBProgram", accounts.tokenBProgram),
      getAccountMeta("eventAuthority", accounts.eventAuthority),
      getAccountMeta("program", accounts.program),
    ],
    data: getClaimPositionFeeInstructionDataEncoder().encode({}),
    programAddress,
  } as ClaimPositionFeeInstruction<
    TProgramAddress,
    TAccountPoolAuthority,
    TAccountPool,
    TAccountPosition,
    TAccountTokenAAccount,
    TAccountTokenBAccount,
    TAccountTokenAVault,
    TAccountTokenBVault,
    TAccountTokenAMint,
    TAccountTokenBMint,
    TAccountPositionNftAccount,
    TAccountOwner,
    TAccountTokenAProgram,
    TAccountTokenBProgram,
    TAccountEventAuthority,
    TAccountProgram
  >);
}

export type ClaimPositionFeeInput<
  TAccountPoolAuthority extends string = string,
  TAccountPool extends string = string,
  TAccountPosition extends string = string,
  TAccountTokenAAccount extends string = string,
  TAccountTokenBAccount extends string = string,
  TAccountTokenAVault extends string = string,
  TAccountTokenBVault extends string = string,
  TAccountTokenAMint extends string = string,
  TAccountTokenBMint extends string = string,
  TAccountPositionNftAccount extends string = string,
  TAccountOwner extends string = string,
  TAccountTokenAProgram extends string = string,
  TAccountTokenBProgram extends string = string,
  TAccountEventAuthority extends string = string,
  TAccountProgram extends string = string,
> = {
  poolAuthority: Address<TAccountPoolAuthority>;
  pool: Address<TAccountPool>;
  position: Address<TAccountPosition>;
  /** The user token a account */
  tokenAAccount: Address<TAccountTokenAAccount>;
  /** The user token b account */
  tokenBAccount: Address<TAccountTokenBAccount>;
  /** The vault token account for input token */
  tokenAVault: Address<TAccountTokenAVault>;
  /** The vault token account for output token */
  tokenBVault: Address<TAccountTokenBVault>;
  /** The mint of token a */
  tokenAMint: Address<TAccountTokenAMint>;
  /** The mint of token b */
  tokenBMint: Address<TAccountTokenBMint>;
  /** The token account for nft */
  positionNftAccount: Address<TAccountPositionNftAccount>;
  /** owner of position */
  owner: TransactionSigner<TAccountOwner>;
  /** Token a program */
  tokenAProgram?: Address<TAccountTokenAProgram>;
  /** Token b program */
  tokenBProgram?: Address<TAccountTokenBProgram>;
  eventAuthority: Address<TAccountEventAuthority>;
  program?: Address<TAccountProgram>;
};

export function getClaimPositionFeeInstruction<
  TAccountPoolAuthority extends string,
  TAccountPool extends string,
  TAccountPosition extends string,
  TAccountTokenAAccount extends string,
  TAccountTokenBAccount extends string,
  TAccountTokenAVault extends string,
  TAccountTokenBVault extends string,
  TAccountTokenAMint extends string,
  TAccountTokenBMint extends string,
  TAccountPositionNftAccount extends string,
  TAccountOwner extends string,
  TAccountTokenAProgram extends string,
  TAccountTokenBProgram extends string,
  TAccountEventAuthority extends string,
  TAccountProgram extends string,
  TProgramAddress extends Address = typeof CP_AMM_PROGRAM_ADDRESS,
>(
  input: ClaimPositionFeeInput<
    TAccountPoolAuthority,
    TAccountPool,
    TAccountPosition,
    TAccountTokenAAccount,
    TAccountTokenBAccount,
    TAccountTokenAVault,
    TAccountTokenBVault,
    TAccountTokenAMint,
    TAccountTokenBMint,
    TAccountPositionNftAccount,
    TAccountOwner,
    TAccountTokenAProgram,
    TAccountTokenBProgram,
    TAccountEventAuthority,
    TAccountProgram
  >,
  config?: { programAddress?: TProgramAddress },
): ClaimPositionFeeInstruction<
  TProgramAddress,
  TAccountPoolAuthority,
  TAccountPool,
  TAccountPosition,
  TAccountTokenAAccount,
  TAccountTokenBAccount,
  TAccountTokenAVault,
  TAccountTokenBVault,
  TAccountTokenAMint,
  TAccountTokenBMint,
  TAccountPositionNftAccount,
  TAccountOwner,
  TAccountTokenAProgram,
  TAccountTokenBProgram,
  TAccountEventAuthority,
  TAccountProgram
> {
  // Program address.
  const programAddress = config?.programAddress ?? CP_AMM_PROGRAM_ADDRESS;

  // Original accounts.
  const originalAccounts = {
    poolAuthority: { value: input.poolAuthority ?? null, isWritable: false },
    pool: { value: input.pool ?? null, isWritable: false },
    position: { value: input.position ?? null, isWritable: true },
    tokenAAccount: { value: input.tokenAAccount ?? null, isWritable: true },
    tokenBAccount: { value: input.tokenBAccount ?? null, isWritable: true },
    tokenAVault: { value: input.tokenAVault ?? null, isWritable: true },
    tokenBVault: { value: input.tokenBVault ?? null, isWritable: true },
    tokenAMint: { value: input.tokenAMint ?? null, isWritable: false },
    tokenBMint: { value: input.tokenBMint ?? null, isWritable: false },
    positionNftAccount: {
      value: input.positionNftAccount ?? null,
      isWritable: false,
    },
    owner: { value: input.owner ?? null, isWritable: false },
    tokenAProgram: { value: input.tokenAProgram ?? null, isWritable: false },
    tokenBProgram: { value: input.tokenBProgram ?? null, isWritable: false },
    eventAuthority: { value: input.eventAuthority ?? null, isWritable: false },
    program: { value: input.program ?? null, isWritable: false },
  };
  const accounts = originalAccounts as Record<
    keyof typeof originalAccounts,
    ResolvedInstructionAccount
  >;

  // Resolve default values.
  if (!accounts.tokenAProgram.value) {
    accounts.tokenAProgram.value =
      "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA" as Address<"TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA">;
  }
  if (!accounts.tokenBProgram.value) {
    accounts.tokenBProgram.value =
      "TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA" as Address<"TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA">;
  }
  if (!accounts.program.value) {
    accounts.program.value =
      "cpamdpZCGKUy5JxQXB4dcpGPiikHawvSWAd6mEn1sGG" as Address<"cpamdpZCGKUy5JxQXB4dcpGPiikHawvSWAd6mEn1sGG">;
  }

  const getAccountMeta = getAccountMetaFactory(programAddress, "programId");
  return Object.freeze({
    accounts: [
      getAccountMeta("poolAuthority", accounts.poolAuthority),
      getAccountMeta("pool", accounts.pool),
      getAccountMeta("position", accounts.position),
      getAccountMeta("tokenAAccount", accounts.tokenAAccount),
      getAccountMeta("tokenBAccount", accounts.tokenBAccount),
      getAccountMeta("tokenAVault", accounts.tokenAVault),
      getAccountMeta("tokenBVault", accounts.tokenBVault),
      getAccountMeta("tokenAMint", accounts.tokenAMint),
      getAccountMeta("tokenBMint", accounts.tokenBMint),
      getAccountMeta("positionNftAccount", accounts.positionNftAccount),
      getAccountMeta("owner", accounts.owner),
      getAccountMeta("tokenAProgram", accounts.tokenAProgram),
      getAccountMeta("tokenBProgram", accounts.tokenBProgram),
      getAccountMeta("eventAuthority", accounts.eventAuthority),
      getAccountMeta("program", accounts.program),
    ],
    data: getClaimPositionFeeInstructionDataEncoder().encode({}),
    programAddress,
  } as ClaimPositionFeeInstruction<
    TProgramAddress,
    TAccountPoolAuthority,
    TAccountPool,
    TAccountPosition,
    TAccountTokenAAccount,
    TAccountTokenBAccount,
    TAccountTokenAVault,
    TAccountTokenBVault,
    TAccountTokenAMint,
    TAccountTokenBMint,
    TAccountPositionNftAccount,
    TAccountOwner,
    TAccountTokenAProgram,
    TAccountTokenBProgram,
    TAccountEventAuthority,
    TAccountProgram
  >);
}

export type ParsedClaimPositionFeeInstruction<
  TProgram extends string = typeof CP_AMM_PROGRAM_ADDRESS,
  TAccountMetas extends readonly AccountMeta[] = readonly AccountMeta[],
> = {
  programAddress: Address<TProgram>;
  accounts: {
    poolAuthority: TAccountMetas[0];
    pool: TAccountMetas[1];
    position: TAccountMetas[2];
    /** The user token a account */
    tokenAAccount: TAccountMetas[3];
    /** The user token b account */
    tokenBAccount: TAccountMetas[4];
    /** The vault token account for input token */
    tokenAVault: TAccountMetas[5];
    /** The vault token account for output token */
    tokenBVault: TAccountMetas[6];
    /** The mint of token a */
    tokenAMint: TAccountMetas[7];
    /** The mint of token b */
    tokenBMint: TAccountMetas[8];
    /** The token account for nft */
    positionNftAccount: TAccountMetas[9];
    /** owner of position */
    owner: TAccountMetas[10];
    /** Token a program */
    tokenAProgram: TAccountMetas[11];
    /** Token b program */
    tokenBProgram: TAccountMetas[12];
    eventAuthority: TAccountMetas[13];
    program: TAccountMetas[14];
  };
  data: ClaimPositionFeeInstructionData;
};

export function parseClaimPositionFeeInstruction<
  TProgram extends string,
  TAccountMetas extends readonly AccountMeta[],
>(
  instruction: Instruction<TProgram> &
    InstructionWithAccounts<TAccountMetas> &
    InstructionWithData<ReadonlyUint8Array>,
): ParsedClaimPositionFeeInstruction<TProgram, TAccountMetas> {
  if (instruction.accounts.length < 15) {
    throw new SolanaError(
      SOLANA_ERROR__PROGRAM_CLIENTS__INSUFFICIENT_ACCOUNT_METAS,
      {
        actualAccountMetas: instruction.accounts.length,
        expectedAccountMetas: 15,
      },
    );
  }
  let accountIndex = 0;
  const getNextAccount = () => {
    const accountMeta = (instruction.accounts as TAccountMetas)[accountIndex]!;
    accountIndex += 1;
    return accountMeta;
  };
  return {
    programAddress: instruction.programAddress,
    accounts: {
      poolAuthority: getNextAccount(),
      pool: getNextAccount(),
      position: getNextAccount(),
      tokenAAccount: getNextAccount(),
      tokenBAccount: getNextAccount(),
      tokenAVault: getNextAccount(),
      tokenBVault: getNextAccount(),
      tokenAMint: getNextAccount(),
      tokenBMint: getNextAccount(),
      positionNftAccount: getNextAccount(),
      owner: getNextAccount(),
      tokenAProgram: getNextAccount(),
      tokenBProgram: getNextAccount(),
      eventAuthority: getNextAccount(),
      program: getNextAccount(),
    },
    data: getClaimPositionFeeInstructionDataDecoder().decode(instruction.data),
  };
}
